<!--年框进度-->
<template>
    <div class="year-frame-schedule-list-container" v-loading="loading">
        <el-form ref="search" inline :model="search" size="mini">
            <el-form-item>
                <customer-remote-select multiple :model-value.sync="search.customer_id"/>
            </el-form-item>
            <el-form-item>
                <PinYinMatchSelect :data="optionSales" :is-multiple="true" placeholder="销售"
                                   :model-value.sync="search.creator_id" @focus="getOptionSales"/>
            </el-form-item>
            <el-form-item>
                <el-select v-model="search.year" filterable placeholder="签约周期包含在内的年份" clearable>
                    <el-option v-for="item in MapYears" :key="item" :label="item" :value="item"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="search.dates_type" filterable placeholder="时间类型" style="width: 100px;">
                    <el-option v-for="(item,field) in MapTypeDate" :key="field" :label="item" :value="field"/>
                </el-select>
                <el-date-picker
                        v-model="search.dates"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handelSearch">查询</el-button>
                <export-by-page module="YEAR_FRAME_SCHEDULE" :search="search" style="margin-left: 8px"/>
            </el-form-item>
        </el-form>
        <div class="year-frame-schedule-list-container__content default-table" :style="`height:${height_content}`">
            <div class="toolbar" style="display: flex;justify-content: space-between;align-items: center;">
                <div>
                    <span>共有&nbsp;{{ search.total }}&nbsp;年框记录</span>
                    <el-tooltip
                            content="总额度即目标投放金额。完成额度为对应签约时间区间内该客户/集团投放金额（含税收入）总和。"
                            placement="right" effect="light">
                        <span style="color: #AAAAAA;margin-left: 10px;cursor: pointer;">数据说明<i
                                class="el-icon-info"/></span>
                    </el-tooltip>
                </div>
                <toolbar-sort :fields="FieldsSort" @change="eventSort"/>
            </div>
            <el-table :data="table" height="calc(100% - 62px)" style="width: 100%" :show-header="false">
                <el-table-column width="350">
                    <template
                            v-slot="{row:{logo_name,customer_id,_target_name,logo_f_size,charge_person,_combine_name}}">
                        <div style="display: flex;align-items: center;">
                            <div class="logo" :style="{fontSize:logo_f_size}">
                                {{ logo_name }}
                            </div>
                            <div style="margin-left: 20px;width: calc(100% - 96px);">
                                <div style="color: #45474d;font-size: 15px;font-weight: bold;">
                                    {{ _target_name }}
                                </div>
                                <div>最高级别负责人：{{ charge_person || '-' }}</div>
                                <div v-if="customer_id">集团：{{ _combine_name }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template v-slot="{row:{_pioneer_name,creator,_then_sales}}">
                        <div>开拓者：{{ _pioneer_name }}</div>
                        <div>销售：{{ _then_sales }}</div>
                        <div>申请人：{{ creator || '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template v-slot="{row:{sign_begin,sign_end,policy_text,pay_method,pay_method_sub}}">
                        <div style="color: #666;">
                            <i class="el-icon-connection"/>{{ sign_begin }}~{{ sign_end }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template v-slot="{row}">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <div style="margin-right: 4px;">
                                <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
                                    {{ row.aim_money|numberFormatW }}
                                </div>
                                <div style="color: #AAAAAA;">总额度</div>
                            </div>
                            <el-button v-permission="'year_frame_schedule_edit_aim'" class="edit-aim" type="primary"
                                       icon="el-icon-edit" circle size="mini"
                                       @click="handelEditAim(row)"/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template v-slot="{row:{order_money}}">
                        <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
                            {{ order_money|numberFormatW }}
                        </div>
                        <div style="color: #AAAAAA;">完成额度</div>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template v-slot="{row:{schedule,aim_money,id}}">
                        <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
                            {{ schedule }}%
                        </div>
                        <el-progress :key="(aim_money||'')+id" :percentage="schedule" :show-text="false"/>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                    background
                    :current-page="search.page"
                    :page-size="search.page_size"
                    layout="total, prev, pager, next"
                    :total="search.total"
                    style="margin-top: 10px;float: right;"
                    @current-change="handleCurrentChange"
            />


            <el-dialog title="修改总额度" :visible.sync="formAim.show" width="450px" center>
                <h2 style="text-align: center;">
                    {{ formAim.name }}
                </h2>
                <el-input
                        :value="formAim.money"
                        placeholder="请输入总额度（万）"
                        @input="handelInputValueInt($event)"
                        style="width: 150px;margin: 0 auto;display: block;"
                >
                    <span slot="suffix" class="el-input__icon iconfont">万</span>
                </el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="formAim.show=false">取消</el-button>
                    <el-button type="primary" @click="handelEditAimSubmit">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {yearFrameModifyAimMoney, yearFrameScheduleList} from "@/api/customerYearFrame";
import {CodeToText} from 'element-china-area-data'
import CustomerRemoteSelect from "../CustomerRemoteSelect.vue";
import moment from "moment/moment";
import {saleOptions} from "@/api/user";
import ExportByPage from "../../../../components/export/ByPage/index.vue";
import ToolbarSort from "@/components/ToolbarSort/index.vue";

const area = Object.values(CodeToText).map((_ => {
    let tmp
    tmp = _.replace(/省/g, "")
    tmp = tmp.replace(/市/g, "")
    tmp = tmp.replace(/区/g, "")
    return tmp
}))

function getStrLenShort(name) {
    const array = [/信息技术有限公司/g, /美妆有限公司/g, /传媒有限公司/g, /科技有限公司/g, /有限公司/g]
    array.forEach(item => {
        name = name.replace(item, "")
    })
    return name
}

const MapYears = []
for (let i = 0, year = ((moment().year()) + 2); i < 8; i++, year--) {
    MapYears.push(year)
}

const MapTypeDate = {
    audit_at: '审核时间',
    created_at: '申请时间',
    sign_begin: '签约开始',
    sign_end: '签约结束',
}

const ModelModifyAim = {
    show: false,
    id: null,
    money: null,
    name: null
}

const FieldsSort = [
    {label: '总额度', field: 'aim_money'},
    {label: '完成额度', field: 'order_money'},
    {label: '完成进度', field: 'schedule'},
]

export default {
    name: "YearFrameSchedule",
    components: {ToolbarSort, ExportByPage, CustomerRemoteSelect},
    data() {
        return {
            MapYears,
            FieldsSort,
            MapTypeDate,
            table: [],
            height_content: 'calc(100% - 48px - 77px)',
            loading: false,
            optionSales: [],
            formAim: {...{}, ...ModelModifyAim},
            search: {
                page: 1,
                page_size: 20,
                total: 0,
                order_by: null
            },
        }
    },
    created() {
        this.init()
    },
    beforeMount() {
        window.addEventListener('resize', this.handelResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handelResize)
    },
    methods: {
        handelResize() {
            this.$nextTick(() => {
                const dom = this.$refs.search
                this.height_content = `calc(100% - 48px - ${dom.$el.offsetHeight}px - 10px)`
            })
        },
        init: function () {
            this.getData()
            this.getOptionSales()
            this.handelResize()
        },
        handelEditAim: function (row) {
            const money = row.aim_money ? (row.aim_money / 10000).toFixed(2) : 0
            this.formAim = {
                show: true,
                id: row.id,
                money,
                name: row.customer ? row.customer.name : ''
            }
        },
        handelEditAimSubmit: async function () {
            const that = this
            const params = {
                id: this.formAim.id,
                aim_money: this.formAim.money * 10000
            }
            const response = await yearFrameModifyAimMoney(params)
            if (!response.success) {
                this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
                return;
            }
            this.formAim.show = false
            this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
            await this.getData()
        },
        handleCurrentChange: function (val) {
            this.search.page = val
            this.getData()
        },
        async getOptionSales() {
            const response = await saleOptions()
            this.optionSales = response.model;
        },
        handelSearch: function () {
            this.page = 1
            this.getData()
        },
        eventSort: function (field, sort) {
            this.search.order_by = field ? `${field} ${sort}` : ''
            this.handelSearch()
        },
        getData: async function () {
            const _this = this
            this.loading = true
            const {model: {data, total}} = await yearFrameScheduleList(this.search)
            this.loading = false
            this.search.total = total || 0
            const table = data || []
            table.map(_ => {
                _.schedule = parseFloat(_.aim_money) > 0 ? parseInt((parseFloat(_.order_money || 0) / parseFloat(_.aim_money || 0) * 100) + '') : 0
                // 超过100 报错
                // _.schedule = _.schedule > 100 ? 100 : _.schedule
                _.logo_name = _this.getShortName(_._target_name)
                _.logo_f_size = '20px'
                switch (_.logo_name.length) {
                    case 4:
                        _.logo_f_size = '26px'
                        break;
                    case 5:
                        _.logo_f_size = '20px'
                        break;
                    case 6:
                        _.logo_f_size = '20px'
                        break;
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                        _.logo_f_size = '17px'
                        break;
                }
            })
            this.table = table
        },
        getShortName: function (name) {
            for (let i = 0; i < area.length; i++) {
                let prefix = area[i]
                if (name.startsWith(prefix)) {
                    name = name.substring(prefix.length)
                }
            }
            return getStrLenShort(name)
        },
        handelInputValueInt: function (value) {
            const _val = value.split(',').join('')
            // eslint-disable-next-line no-empty
            if (isNaN(Number(_val))) {

            } else {
                const _indexOf = _val.indexOf('.')
                if (_indexOf >= 0) {
                    if ((_val.length - 1 - _indexOf <= 2)) {
                        this.formAim.money = _val
                    }
                } else {
                    this.formAim.money = _val
                }
            }
        },
    }
}
</script>
<style lang="scss">
.year-frame-schedule-list-container {
  font-family: FjallaOne-Regular, sans-serif !important;
  padding: 24px;
  background: #F5F6FA;
  height: calc(100% - 48px);

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .el-form {
    border-radius: 8px;
    background: #FFFFFF;
    margin-bottom: 12px;
    padding: 18px 18px 10px 18px;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 8px !important;
  }

  &__content {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 24px 30px;
    position: relative;
  }

  .el-pagination {
  }

  .default-table tr.el-table__row .cell {
    height: unset !important;
    line-height: unset !important;

  }

  .el-icon-notebook-2, .el-icon-connection, .el-icon-coin {
    color: #fe346e;
    margin-right: 4px;
    font-size: 14px;
    font-weight: 600;
  }

  .logo {
    font-family: FjallaOne-Regular, sans-serif !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 600;
    width: 76px;
    height: 76px;
    background: #ffeef3;
    color: #fe346e;
    line-height: 1.2;
  }

  .ellipsis {
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }

  .el-table td, .el-table th {
    padding: 14px 0 !important;
  }

  .el-table__row {
    cursor: pointer;
  }

  .edit-aim {
    opacity: 0;
    width: 30px;
    height: 30px;
  }

  .el-table__row:hover {
    .edit-aim {
      opacity: 1;
    }
  }

  .el-dialog {
    width: 300px;
    border-radius: 20px;

    .el-input__suffix {
      right: 12px !important;
    }
  }

  .toolbar {
    padding-bottom: 12px;
    border-bottom: 1px solid #F2F2F2;
  }
}
</style>
